import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PetitionsComponent } from './petitions.component';
import { PerformanceIndexVsPriceIndexComponent } from './performance-index-vs-price-index/performance-index-vs-price-index.component';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SocialMediaModule } from '../_components/social-media/social-media.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TickerGlobalIndexesModule } from '../_components/tickers/ticker-global-indexes/ticker-global-indexes.module';
import { MorningstarTotalAndPriceReturnsModule } from '../_components/widgets/morningstar-total-and-price-returns/morningstar-total-and-price-returns.module';
import { BannerDowOneHundredKModule } from "../_components/banners/banner-dow-one-hundred-k/banner-dow-one-hundred-k.module";
import { JumbotronComponent } from '../_components/jumbotron/jumbotron.component';
import { ChartEmbedComponent } from '../_components/chart-embed/chart-embed.component';



@NgModule({
  declarations: [
    PetitionsComponent,
    PerformanceIndexVsPriceIndexComponent
  ],
  imports: [
    BannerDowOneHundredKModule,
    CommonModule,
    ChartEmbedComponent,
    JumbotronComponent,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    SocialMediaModule,
    TickerGlobalIndexesModule,
    MorningstarTotalAndPriceReturnsModule,
    RouterModule.forChild([
        { path: '', component: PerformanceIndexVsPriceIndexComponent },
        { path: 'performance-index-vs-price-index', component: PerformanceIndexVsPriceIndexComponent }
    ]),
    
]
})
export class PetitionsModule { }
